import React, { Component } from 'react';
import PropTypes from 'prop-types';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import {
  SR_API_ACTION_APARTMENT_SPECIAL_DEAL_UPSERT,
} from 'api/actionTypes';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrTable from 'client/components/SrTable';
import SrApartmentSpecialDealModal from 'client/components/SrApartmentSpecialDealModal';

import postWithState from 'client/actions/postWithState';

class SrTableApartmentSpecialDeals extends Component {
  static propTypes = {
    floorPlans: PropTypes.array,
    apartmentSpecialDeals: PropTypes.array.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      apartmentSpecialDealModalProps: null,
    };
  }

  _onChangeApartmentSpecialDeal = () => {
    this._onCloseApartmentSpecialDealModal();
    this.props.onChange();
  }

  _onClickEditApartmentSpecialDeal = (e) => {
    const { apartmentSpecialDeals } = this.props;
    const apartmentSpecialDealId = parseInt(e.target.dataset.id, 10);
    this.setState({
      apartmentSpecialDealModalProps: {
        apartmentSpecialDeal: apartmentSpecialDeals.find(({ id }) => id === apartmentSpecialDealId),
      },
    });
  }

  _onCloseApartmentSpecialDealModal = () => {
    this.setState({
      apartmentSpecialDealModalProps: null,
    });
  }

  _onHideApartmentSpecialDeal = (e) => {
    const { apartmentSpecialDeals, dispatch, onChange } = this.props;
    const apartmentSpecialDealId = parseInt(e.target.dataset.id, 10);
    const apartmentSpecialDeal = apartmentSpecialDeals.find(({ id }) => id === apartmentSpecialDealId);

    if (
      !global.confirm(`Are you sure you want to hide the special deal "${apartmentSpecialDeal.headline}"?`)
    ) {
      return;
    }

    dispatch(postWithState, {
      action: SR_API_ACTION_APARTMENT_SPECIAL_DEAL_UPSERT,
      payload: {
        id: apartmentSpecialDeal.id,
        endDate: momentWithAustinTimezone().subtract(1, 'day').toISOString(),
      },
      onSuccess: onChange,
      onError: (err) => {
        global.alert(`Error: "${err.message}"`);
      },
    });
  }

  render() {
    const { floorPlans, apartmentSpecialDeals, dispatch } = this.props;
    const { apartmentSpecialDealModalProps } = this.state;

    return (
      <div>
        <SrTable
          headers={[
            { content: 'id' },
            { content: 'headline' },
            { content: 'terms' },
            { content: 'description' },
            { content: 'emoji' },
            { content: 'floor plan' },
            { content: 'units' },
            { content: 'end date' },
            { content: 'options', width: 10 },
          ]}
          rows={apartmentSpecialDeals.map((apartmentSpecialDeal) => ({
            cells: [
              { content: apartmentSpecialDeal.id },
              { content: apartmentSpecialDeal.headline },
              { content: apartmentSpecialDeal.terms },
              { content: apartmentSpecialDeal.description },
              { content: apartmentSpecialDeal.emoji },
              {
                content: (apartmentSpecialDeal.floorPlanId
                  ? floorPlans.find(({ id }) => id === apartmentSpecialDeal.floorPlanId).displayName
                  : null
                ),
              },
              { content: (apartmentSpecialDeal.applicableApartmentUnits || []).join(', ') },
              {
                content: apartmentSpecialDeal.endDate
                  ? momentWithAustinTimezone(apartmentSpecialDeal.endDate).format('MM/DD/YYYY')
                  : '',
              },
              {
                content: (
                  <div>
                    <SrText
                      cursor='pointer'
                      color='blue300'
                      data-id={apartmentSpecialDeal.id}
                      onClick={this._onClickEditApartmentSpecialDeal}
                    >
                      Edit
                    </SrText>
                    <SrBox display='inlineBlock' width={10} />
                    <SrText
                      cursor='pointer'
                      color='blue300'
                      data-id={apartmentSpecialDeal.id}
                      onClick={this._onHideApartmentSpecialDeal}
                    >
                      Hide
                    </SrText>
                  </div>
                ),
              },
            ],
          }))}
        />

        {apartmentSpecialDealModalProps && (
          <SrApartmentSpecialDealModal
            {...apartmentSpecialDealModalProps}
            floorPlans={floorPlans}
            onChange={this._onChangeApartmentSpecialDeal}
            onClose={this._onCloseApartmentSpecialDealModal}
            dispatch={dispatch}
          />
        )}
      </div>
    );
  }
}

SrTableApartmentSpecialDeals.displayName = 'SrTableApartmentSpecialDeals';

export default SrTableApartmentSpecialDeals;
